import { Grid, Typography } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import React from 'react';

import { muiStyles } from './transactionStyles';

interface ITransactionProcessingProps extends WithStyles<typeof muiStyles> {
    text: string;
}

export function TransactionProcessingComponent (props: ITransactionProcessingProps) {
    const {
        classes,
        text
    } = props;

    return (
        <Grid
            alignItems='center'
            container
            direction='column'
            spacing={0}
        >
            <Typography
                align='center'
                className={classes.processingText}
                variant='h5'
            >{text}
            </Typography>
        </Grid>
    );
}

const TransactionProcessing = withStyles(muiStyles)(TransactionProcessingComponent);
export { TransactionProcessing };